import i18n from '@/plugins/i18n';
import utils from '@/utils/functions';

export const affiliatesColumns = () => [
  {
    key: 'name',
    label: i18n.t('Name')
  },
  {
    key: 'reward_mark_count',
    label: i18n.t('Reward Mark Count')
  },
  {
    key: 'reward_mark',
    label: i18n.t('Reward Mark'),
    formatter: utils.formatMoneyPositive
  },
  {
    key: 'reward_accumulative',
    label: i18n.t('Reward Accumulative'),
    formatter: utils.formatMoneyPositive
  },
  {
    key: 'gross_value',
    label: i18n.t('Gross Value'),
    formatter: utils.formatMoneyPositive
  },
  {
    key: 'admin_fee',
    label: i18n.t('Admin Fee'),
    formatter: utils.formatMoneyPositive
  },
  {
    key: 'reward_total',
    label: i18n.t('Reward Total'),
    formatter: utils.formatMoneyPositive
  }
];

export const partnersColumns = () => [
  {
    key: 'name',
    label: i18n.t('Name')
  },
  {
    key: 'level',
    label: i18n.t('Level')
  },
  {
    key: 'percentage',
    label: i18n.t('Percentage'),
    formatter: utils.formatPercent
  },
  {
    key: 'gross_value',
    label: i18n.t('Gross Value'),
    formatter: utils.formatMoneyPositive
  },
  {
    key: 'reward_value',
    label: i18n.t('Reward Value'),
    formatter: utils.formatMoneyPositive
  }
];
